import axios from 'axios'

var qs = require('qs');
var root=window.API_ROOT


//获取列表数据
export const getParameterListData = (params) => {
  return axios.post(root+'/set/parameter/list', qs.stringify(params))
}

export const globallist = (params) => {
  return axios.post(root+'/set/parameter/globallist', qs.stringify(params))
}

//删除行
export const deleteParameterData = (params) => {
  return axios.post(root+'/set/parameter/remove',  qs.stringify(params))
}

//获取某一行的明细数据
export const getParameterDetail = (params) => {
  return axios.get(root+'/set/parameter/detail',  {params:params})
}

export const detailglob = (params) => {
  return axios.get(root+'/set/parameter/detailglob',  {params:params})
}


//保存某一行的数据
export const saveParameterData = (params) => {
  if (params.uguid) {//修改
    return axios.post(root+'/set/parameter/update', qs.stringify(params))
    // return axios.post(root+'/set/employee/update', params,{headers:{"Content-Type":"application/json"}})
  } else {//添加
    return axios.post(root+'/set/parameter/save', qs.stringify(params))
  }
}

export const getAddressListData=(params)=>{
  return axios.post(root+'/set/address/list', qs.stringify(params))
}

//获取物流信息
export const getExpressWL=(params)=> {
  return axios.post(root + '/api/express/list', qs.stringify(params))
}









// WEBPACK FOOTER //
// ./src/api/set/parameter.js